<template>
  <div :class="['dialog', { visible: visible }]">
    <div class="title">校园餐订单</div>
    <div class="closeBtn" @click="visible = false"></div>
    <div class="content">
      <a-table
        bordered
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :scroll="{ y: 1050 }"
        @change="onChange"
      >
        <template slot="materialNames" slot-scope="text">
          <div style="text-align:left;line-height:1.4em">{{ text }}</div>
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
import { groupOrderPage } from '@/api/dashboard'
import to from 'await-to'
export default {
  name: 'UserOrder',
  data() {
    return {
      visible: false,
      columns: [
        // { title: '校园餐订单号', dataIndex: 'gmOutOrderId', width: 140 },
        {
          title: '采购订单号',
          dataIndex: 'gmOrderId',
          width: 120,
          align: 'center',
        },
        {
          title: '采购主体名称',
          dataIndex: 'gmCustomerName',
          width: 200,
          align: 'center',
        },
        {
          title: '期望送达时间',
          dataIndex: 'expectedDeliveryTime',
          width: 120,
          align: 'center',
        },
        {
          title: '下单机构',
          dataIndex: 'storeName',
          width: 70,
          align: 'center',
        },
        {
          title: '采购商品',
          dataIndex: 'materialNames',
          width: 300,
          align: 'center',
          scopedSlots: { customRender: 'materialNames' },
        },
        {
          title: '下单金额',
          dataIndex: 'totalAmount',
          width: 70,
          align: 'center',
        },
        // { title: '供应商供货金额', dataIndex: 'allocatePriceTotal', width: 90 },
        // { title: '万象入库金额', dataIndex: 'wxPutActualTotalPriceTotal', width: 80 },
        // { title: '万象发货金额', dataIndex: 'wxDeliveryTotalPriceTotal', width: 80 },
        // { title: '仓库入库金额', dataIndex: 'ckPutTotalPriceTotal', width: 80 },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 150,
          align: 'center',
        },
        // { title: '创建人', dataIndex: 'createSerialName', width: 100 },
        {
          title: '下单日期',
          dataIndex: 'orderTime',
          width: 120,
          align: 'center',
        },
      ],
      list: [],
      pagination: {
        current: 1,
        pageSize: 11,
        total: 0,
      },
    }
  },
  methods: {
    show() {
      this.visible = true
      this.initData()
    },
    close() {
      this.visible = false
    },
    async initData() {
      const [res, err] = await to(
        groupOrderPage({ current: this.pagination.current, size: this.pagination.pageSize }),
      )
      if (err) return
      this.list = res.data.list
      this.pagination.total = res.data.total
    },
    onChange({ current }) {
      this.pagination.current = current
      this.initData()
    },
  },
}
</script>
<style lang="scss" scoped>
.dialog {
  z-index: 99999999;
  width: 3212px !important;
  height: 1564px !important;
  background: url('~@/img/datav/dialog_bg.png');
  background-size: 100% 100%;
  position: absolute;
  left: 329px;
  top: 423px;
  display: none;

  .title {
    font-size: 57px;
    text-align: center;
    line-height: 107px;
    margin-bottom: 87px;
  }

  .closeBtn {
    cursor: pointer;
    width: 58px;
    height: 58px;
    position: absolute;
    right: 40px;
    top: 34px;
    background: url('~@/img/datav/dialog_close_btn.png');
    background-size: 100% 100%;
  }

  .content {
    padding: 0 62px;

    ::v-deep .ant-table {
      p {
        margin-bottom: 10px;
      }

      table {
        border-left: 1px solid #f5f5f5;
        border-top: 1px solid #f5f5f5;
      }

      .ant-table-thead {
        box-sizing: border-box;
        border: 0;
        border-color: #f5f5f5;
        font-size: 36px;
        line-height: 36px;
        background: #fff linear-gradient(180deg, #145fa3, #174da8);

        > tr > th {
          background: transparent;
          color: #fff;
          border-color: #f5f5f5;
          padding-top: 42px;
          padding-bottom: 42px;
        }
      }

      .ant-table-header {
        background: transparent;
      }

      .ant-table-body {
        background: transparent;

        /* 设置滚动条的样式 */
        &::-webkit-scrollbar {
          border-radius: 15px;
          width: 17px;
          background-color: transparent;
        }

        /* 滚动槽 */
        &::-webkit-scrollbar-track {
          border-radius: 15px;
          background-color: transparent;
        }

        /* 滚动条滑块 */
        &::-webkit-scrollbar-thumb {
          border-radius: 15px;
          background: #46629a;
        }
      }

      .ant-table-tbody {
        font-size: 30px;
        line-height: 30px;
        color: #fff;

        > tr > td {
          border-color: #f5f5f5;
          padding-top: 29px;
          padding-bottom: 29px;
        }

        > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
          background: transparent;
        }
      }

      .ant-table-placeholder {
        background: transparent;
      }
    }

    ::v-deep .ant-pagination {
      width: 100%;
      text-align: center;
      padding-top: 33px;

      > li {
        width: 58px;
        height: 58px;
        box-sizing: border-box;
        border: 2px solid #46639a;
        font-weight: normal;
        font-size: 24px;
        line-height: 54px;
        text-align: center;
        background-color: transparent;
        margin: 0 10px;

        .ant-pagination-item-link {
          background-color: transparent;
          border: 0;
        }

        a {
          color: #46629a;
        }

        &.ant-pagination-item-active {
          background-color: #46629a;

          a {
            color: #fff;
          }
        }

        .ant-pagination-item-ellipsis {
          font-size: 12px;
          color: #46629a;
        }
      }
    }
  }

  &.visible {
    display: block;
    animation: anim-open 0.5s ease;
  }

  @keyframes anim-open {
    0% {
      transform: scale(0);
    }

    100% {
      transform: scale(1);
    }
  }
}
</style>
